import React from "react";
import './component.scss'

export default function ShimmerLoading() {
    return (
        <div className="bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 animate-shimmer rounded-lg w-full h-full"></div>
    );
}